<template>
  <div class="row justify-content-md-center mb-3">
    <div class="w-100"></div>
    <div class="col-12 col-lg-6 offset-lg-3 mr-auto mx-auto mb-3 p-2 ">
      <div v-if="step !== 5" class="w-100 alert alert-primary text-right hora-steps-text m-0 border-0" style="background: #fcf8e3 !important;color: #ba8c5b !important;">
        <div v-html="stepText()"></div>
      </div>
    </div>
    <div class="wizard-form">
      <div v-if="step === 1">
        <div class="step">
          <div class="col-12 col-lg-6 offset-lg-3 lg:py-0  ">
            <div class="grid content-start">
              <div class="hora-form-step">
                <div class="hora-form-name mb-6">
                  <div class="flex flex-row items-center gap-2.5 mb-6">
                    <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_6_370)">
                        <path d="M13 5C13 4.50754 12.903 4.01991 12.7145 3.56494C12.5261 3.10997 12.2499 2.69657 11.9017 2.34835C11.5534 2.00013 11.14 1.72391 10.6851 1.53545C10.2301 1.347 9.74246 1.25 9.25 1.25C8.75754 1.25 8.26991 1.347 7.81494 1.53545C7.35997 1.72391 6.94657 2.00013 6.59835 2.34835C6.25013 2.69657 5.97391 3.10997 5.78545 3.56494C5.597 4.01991 5.5 4.50754 5.5 5C5.5 5.49246 5.597 5.98009 5.78545 6.43506C5.97391 6.89003 6.25013 7.30343 6.59835 7.65165C6.94657 7.99987 7.35997 8.27609 7.81494 8.46455C8.26991 8.653 8.75754 8.75 9.25 8.75C9.74246 8.75 10.2301 8.653 10.6851 8.46455C11.14 8.27609 11.5534 7.99987 11.9017 7.65165C12.2499 7.30343 12.5261 6.89003 12.7145 6.43506C12.903 5.98009 13 5.49246 13 5ZM4.25 5C4.25 3.67392 4.77678 2.40215 5.71447 1.46447C6.65215 0.526784 7.92392 0 9.25 0C10.5761 0 11.8479 0.526784 12.7855 1.46447C13.7232 2.40215 14.25 3.67392 14.25 5C14.25 6.32608 13.7232 7.59785 12.7855 8.53553C11.8479 9.47322 10.5761 10 9.25 10C7.92392 10 6.65215 9.47322 5.71447 8.53553C4.77678 7.59785 4.25 6.32608 4.25 5ZM1.75 18.75H16.75C16.7031 15.6367 14.1641 13.125 11.0352 13.125H7.46484C4.33984 13.125 1.80078 15.6367 1.75 18.75ZM0.5 18.8398C0.5 14.9922 3.61719 11.875 7.46484 11.875H11.0352C14.8828 11.875 18 14.9922 18 18.8398C18 19.4805 17.4805 20 16.8398 20H1.66016C1.01953 20 0.5 19.4805 0.5 18.8398Z" fill="#002E5B"/>
                      </g>
                      <defs>
                        <clipPath id="clip0_6_370">
                          <rect width="17.5" height="20" fill="white" transform="translate(0.5)"/>
                        </clipPath>
                      </defs>
                    </svg>
                    <h5 class="hora-text-primary inline text-xl m-0">نام</h5>
                  </div>
                  <div class="mb-3">
                    <div v-if="errors.name_error"
                         :style="`
                text-align: center;
                display: ${errors.name_error};
                border-radius: 8px;
                line-height: 40px;
                border: 1px solid rgba(255, 0, 51, 0.3);
                font-size: 14px;
                margin-bottom: 8px;
                color: red;
                text-shadow: rgb(255, 255, 255) 1px 1px;`"
                    >
                      این فیلد الزامی است. نام حداقل باید از ۲ حرف باشد.
                    </div>
                    <input id="name" v-model="chart_request.title" name="name" placeholder="نام خود را وارد نمایید" type="text" class="block w-full text-slate-500 placeholder:text-slate-500 rounded-lg bg-slate-100 py-2 px-3 border border-slate-200">
                  </div>
                </div>
                <hr>
                <div class="hora-form-gender mt-6 mb-6">
                  <div class="flex flex-row items-center gap-2.5">
                    <svg width="25" height="20" viewBox="0 0 25 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_8_45)">
                        <path d="M6.875 12.5C8.36684 12.5 9.79758 11.9074 10.8525 10.8525C11.9074 9.79758 12.5 8.36684 12.5 6.875C12.5 5.38316 11.9074 3.95242 10.8525 2.89752C9.79758 1.84263 8.36684 1.25 6.875 1.25C5.38316 1.25 3.95242 1.84263 2.89752 2.89752C1.84263 3.95242 1.25 5.38316 1.25 6.875C1.25 8.36684 1.84263 9.79758 2.89752 10.8525C3.95242 11.9074 5.38316 12.5 6.875 12.5ZM13.75 6.875C13.75 10.4609 11.0039 13.4062 7.5 13.7227V16.25H10C10.3438 16.25 10.625 16.5312 10.625 16.875C10.625 17.2188 10.3438 17.5 10 17.5H7.5V19.375C7.5 19.7188 7.21875 20 6.875 20C6.53125 20 6.25 19.7188 6.25 19.375V17.5H3.75C3.40625 17.5 3.125 17.2188 3.125 16.875C3.125 16.5312 3.40625 16.25 3.75 16.25H6.25V13.7227C2.74609 13.4062 0 10.4609 0 6.875C0 3.07812 3.07812 0 6.875 0C10.6719 0 13.75 3.07812 13.75 6.875ZM10.6211 14.0859C11 13.8867 11.3633 13.6602 11.707 13.4062C12.7188 14.3945 14.1016 15 15.625 15C18.7305 15 21.25 12.4805 21.25 9.375C21.25 6.26953 18.7305 3.75 15.625 3.75C15.2148 3.75 14.8164 3.79297 14.4297 3.87891C14.2695 3.48047 14.082 3.09375 13.8633 2.73047C14.4258 2.57812 15.0156 2.5 15.625 2.5C17.2969 2.5 18.832 3.09766 20.0234 4.08984L22.8672 1.25H19.375C19.0312 1.25 18.75 0.96875 18.75 0.625C18.75 0.28125 19.0312 0 19.375 0H24.375C24.7188 0 25 0.28125 25 0.625V5.625C25 5.96875 24.7188 6.25 24.375 6.25C24.0312 6.25 23.75 5.96875 23.75 5.625V2.13281L20.9102 4.97266C21.9023 6.16797 22.5 7.70312 22.5 9.375C22.5 13.1719 19.4219 16.25 15.625 16.25C13.6523 16.25 11.875 15.418 10.6211 14.0859Z" fill="#002E5B"/>
                      </g>
                      <defs>
                        <clipPath id="clip0_8_45">
                          <rect width="25" height="20" fill="white"/>
                        </clipPath>
                      </defs>
                    </svg>
                    <h5 class="hora-text-primary inline text-xl پ-۰">جنسیت</h5>
                  </div>
                  <div class="mt-6">
                    <div
                         :style="`
              text-align: center;
              border-radius: 8px;
              display: ${errors.gender_error};
              line-height: 40px;
              border: 1px solid rgba(255, 0, 51, 0.3);
              font-size: 14px;
              margin-bottom: 8px;
              color: red;
              text-shadow: rgb(255, 255, 255) 1px 1px;`"
                    >
                      جنسیت خود را انتخاب کنید
                    </div>
                    <div class="relative">
                      <select v-model="chart_request.gender" name="gender" id="gender" class="block w-full text-slate-500 placeholder:text-slate-500 rounded-lg bg-slate-100 py-2 px-3 border border-slate-200 mb-5">
                        <option value="null" disabled>جنسیت</option>
                        <option value="0">زن</option>
                        <option value="1">مرد</option>
                        <option value="2">non-binary/other</option>
                      </select>
                      <div class="pointer-events-none absolute inset-y-0 left-0 flex items-center px-4 text-gray-700">
                        <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M6.64687 11.3531C6.84062 11.5469 7.15937 11.5469 7.35312 11.3531L12.3531 6.35315C12.5469 6.1594 12.5469 5.84065 12.3531 5.6469C12.1594 5.45315 11.8406 5.45315 11.6469 5.6469L6.99999 10.2938L2.35312 5.6469C2.15937 5.45315 1.84062 5.45315 1.64687 5.6469C1.45312 5.84065 1.45312 6.1594 1.64687 6.35315L6.64687 11.3531Z" fill="#64748B"/>
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="hora-form-buttons grid grid-cols-2 gap-4">
                <a target="_blank"
                   :href="`${this.site_url}/privacy-policy`"
                   style="text-decoration: none" class="no-underline text-black flex justify-center relative items-center rounded-lg py-2 px-3 text-slate-400 bg-slate-200 border border-slate-300" disabled>
                  <span class="text-black">  حریم خصوصی</span>
                </a>
                <a  id="nextStep01" @click="nextStep"  class="flex justify-center relative items-center rounded-lg py-2 px-3 hora-bg-primary text-white">
                  <span class="">  بعدی</span>
                  <svg class="absolute left-3" width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_6_380)">
                      <path d="M0.146899 7.64687C-0.0468506 7.84062 -0.0468506 8.15937 0.146899 8.35312L5.6469 13.8531C5.84065 14.0469 6.1594 14.0469 6.35315 13.8531C6.5469 13.6594 6.5469 13.3406 6.35315 13.1469L1.70627 8.49999H13.5C13.775 8.49999 14 8.27499 14 7.99999C14 7.72499 13.775 7.49999 13.5 7.49999H1.70627L6.35315 2.85312C6.5469 2.65937 6.5469 2.34062 6.35315 2.14687C6.1594 1.95312 5.84065 1.95312 5.6469 2.14687L0.146899 7.64687Z" fill="white"/>
                    </g>
                    <defs>
                      <clipPath id="clip0_6_380">
                        <rect width="14" height="16" fill="white"/>
                      </clipPath>
                    </defs>
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="step === 2">
        <div class="step" id="step-2">
          <div class="col-12 col-lg-6 offset-lg-3  py-12 lg:py-0  ">
            <div class="grid content-start">
              <div class="hora-form-step">
                <div class="hora-form-date mb-10">
                  <div class="flex flex-row items-center gap-2.5">
                    <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_8_66)">
                        <path d="M4.375 0C4.71875 0 5 0.28125 5 0.625V2.5H12.5V0.625C12.5 0.28125 12.7812 0 13.125 0C13.4688 0 13.75 0.28125 13.75 0.625V2.5H15C16.3789 2.5 17.5 3.62109 17.5 5V6.25V7.5V17.5C17.5 18.8789 16.3789 20 15 20H2.5C1.12109 20 0 18.8789 0 17.5V7.5V6.25V5C0 3.62109 1.12109 2.5 2.5 2.5H3.75V0.625C3.75 0.28125 4.03125 0 4.375 0ZM16.25 7.5H12.1875V10.3125H16.25V7.5ZM16.25 11.5625H12.1875V14.6875H16.25V11.5625ZM16.25 15.9375H12.1875V18.75H15C15.6914 18.75 16.25 18.1914 16.25 17.5V15.9375ZM10.9375 14.6875V11.5625H6.5625V14.6875H10.9375ZM6.5625 15.9375V18.75H10.9375V15.9375H6.5625ZM5.3125 14.6875V11.5625H1.25V14.6875H5.3125ZM1.25 15.9375V17.5C1.25 18.1914 1.80859 18.75 2.5 18.75H5.3125V15.9375H1.25ZM1.25 10.3125H5.3125V7.5H1.25V10.3125ZM6.5625 10.3125H10.9375V7.5H6.5625V10.3125ZM15 3.75H2.5C1.80859 3.75 1.25 4.30859 1.25 5V6.25H16.25V5C16.25 4.30859 15.6914 3.75 15 3.75Z" fill="#002E5B"/>
                      </g>
                      <defs>
                        <clipPath id="clip0_8_66">
                          <rect width="17.5" height="20" fill="white"/>
                        </clipPath>
                      </defs>
                    </svg>
                    <h5 class="hora-text-primary inline text-xl m-0">تاریخ تولد</h5>
                  </div>
                  <div class="mt-6">
                    <DatePicker
                      :limit_future_range="true"
                      :limit_under_18y="false"
                      :custom_number_en="2024"
                      :custom_number_fa="1403"
                      @updateValidaDateVar="updateValidDate"
                      @updateDatePickerForm="updateFormDate"
                    ></DatePicker>
                    <div v-if="errors.date_error"
                         class="input-group p-2"
                         :style="`
              text-align: center;
              border-radius: 8px;;
              border: 1px solid rgba(255, 0, 51, 0.3);
              display: ${errors.date_error};
              direction: rtl;
              font-size: 14px;
              margin-top: 8px;
              color: red;
              text-shadow: rgb(255, 255, 255) 1px 1px;`"
                    >
                      تاریخ نامعتبر است.
                    </div>
                  </div>
                </div>
              </div>
              <div class="hora-form-buttons grid grid-cols-2 gap-4">
                <a @click="previousStep" class="flex justify-center relative relative items-center rounded-lg py-2 px-3 text-slate-400 bg-slate-200 border border-slate-300" disabled>
                  <svg class="absolute right-3" width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13.8531 8.35313C14.0469 8.15938 14.0469 7.84063 13.8531 7.64688L8.3531 2.14688C8.15935 1.95313 7.8406 1.95313 7.64685 2.14688C7.4531 2.34063 7.4531 2.65938 7.64685 2.85313L12.2937 7.50001L0.499976 7.50001C0.224976 7.5 -2.42471e-05 7.725 -2.42711e-05 8C-2.42952e-05 8.27501 0.224976 8.5 0.499976 8.50001L12.2937 8.50001L7.64685 13.1469C7.4531 13.3406 7.4531 13.6594 7.64685 13.8531C7.8406 14.0469 8.15935 14.0469 8.3531 13.8531L13.8531 8.35313Z" fill="#002E5B"/>
                  </svg>
                  <span>  قبلی</span>
                </a>
                <a id="nextStep01" @click="nextStep"  class="flex justify-center relative items-center rounded-lg py-2 px-3 hora-bg-primary text-white">
                  <span>  بعدی</span>
                  <svg class="absolute left-3" width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_6_380)">
                      <path d="M0.146899 7.64687C-0.0468506 7.84062 -0.0468506 8.15937 0.146899 8.35312L5.6469 13.8531C5.84065 14.0469 6.1594 14.0469 6.35315 13.8531C6.5469 13.6594 6.5469 13.3406 6.35315 13.1469L1.70627 8.49999H13.5C13.775 8.49999 14 8.27499 14 7.99999C14 7.72499 13.775 7.49999 13.5 7.49999H1.70627L6.35315 2.85312C6.5469 2.65937 6.5469 2.34062 6.35315 2.14687C6.1594 1.95312 5.84065 1.95312 5.6469 2.14687L0.146899 7.64687Z" fill="white"/>
                    </g>
                    <defs>
                      <clipPath id="clip0_6_380">
                        <rect width="14" height="16" fill="white"/>
                      </clipPath>
                    </defs>
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="step === 3">
        <div class="step " id="step-3">
          <div class="col-12 col-lg-6 offset-lg-3  py-12 lg:py-0  ">
            <div class="grid content-start">
              <div class="hora-form-step">
                <div class="hora-form-clock mb-10">
                  <div class="flex flex-row items-center gap-2.5">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_8_132)">
                        <path d="M18.75 10C18.75 12.3206 17.8281 14.5462 16.1872 16.1872C14.5462 17.8281 12.3206 18.75 10 18.75C7.67936 18.75 5.45376 17.8281 3.81282 16.1872C2.17187 14.5462 1.25 12.3206 1.25 10C1.25 7.67936 2.17187 5.45376 3.81282 3.81282C5.45376 2.17187 7.67936 1.25 10 1.25C12.3206 1.25 14.5462 2.17187 16.1872 3.81282C17.8281 5.45376 18.75 7.67936 18.75 10ZM0 10C0 12.6522 1.05357 15.1957 2.92893 17.0711C4.8043 18.9464 7.34784 20 10 20C12.6522 20 15.1957 18.9464 17.0711 17.0711C18.9464 15.1957 20 12.6522 20 10C20 7.34784 18.9464 4.8043 17.0711 2.92893C15.1957 1.05357 12.6522 0 10 0C7.34784 0 4.8043 1.05357 2.92893 2.92893C1.05357 4.8043 0 7.34784 0 10ZM9.375 4.375V10C9.375 10.207 9.48047 10.4023 9.65234 10.5195L13.4023 13.0195C13.6914 13.2109 14.0781 13.1328 14.2695 12.8477C14.4609 12.5625 14.3828 12.1719 14.0977 11.9805L10.625 9.66406V4.375C10.625 4.03125 10.3438 3.75 10 3.75C9.65625 3.75 9.375 4.03125 9.375 4.375Z" fill="#002E5B"/>
                      </g>
                      <defs>
                        <clipPath id="clip0_8_132">
                          <rect width="20" height="20" fill="white"/>
                        </clipPath>
                      </defs>
                    </svg>
                    <h5 class="hora-text-primary inline text-xl m-0">ساعت تولد</h5>
                  </div>
                  <div class="mt-6">
                    <TimePicker @updateTimePickerForm="updateFormTime"></TimePicker>
                    <div v-if="errors.time_error"
                         class="input-group p-2"
                         :style="`
              text-align: center;
              border-radius: 8px;;
              border: 1px solid rgba(255, 0, 51, 0.3);
              display:${errors.time_error};
              direction: rtl;
              font-size: 14px;
              margin-top: 8px;
              color: red;
              text-shadow: rgb(255, 255, 255) 1px 1px;`"
                    >
                      زمان نامعتبر است.
                    </div>
                  </div>
                </div>
              </div>
              <div class="hora-form-buttons grid grid-cols-2 gap-4">
                <a  @click="previousStep" class="flex justify-center relative items-center rounded-lg py-2 px-3 text-slate-400 bg-slate-200 border border-slate-300" disabled>
                  <svg  class="absolute right-3" width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13.8531 8.35313C14.0469 8.15938 14.0469 7.84063 13.8531 7.64688L8.3531 2.14688C8.15935 1.95313 7.8406 1.95313 7.64685 2.14688C7.4531 2.34063 7.4531 2.65938 7.64685 2.85313L12.2937 7.50001L0.499976 7.50001C0.224976 7.5 -2.42471e-05 7.725 -2.42711e-05 8C-2.42952e-05 8.27501 0.224976 8.5 0.499976 8.50001L12.2937 8.50001L7.64685 13.1469C7.4531 13.3406 7.4531 13.6594 7.64685 13.8531C7.8406 14.0469 8.15935 14.0469 8.3531 13.8531L13.8531 8.35313Z" fill="#002E5B"/>
                  </svg>
                  <span>  قبلی</span>
                </a>
                <a  id="nextStep01" @click="nextStep"  class="flex justify-center relative items-center rounded-lg py-2 px-3 hora-bg-primary text-white">
                  <span>  بعدی</span>
                  <svg class="absolute left-3" width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_6_380)">
                      <path d="M0.146899 7.64687C-0.0468506 7.84062 -0.0468506 8.15937 0.146899 8.35312L5.6469 13.8531C5.84065 14.0469 6.1594 14.0469 6.35315 13.8531C6.5469 13.6594 6.5469 13.3406 6.35315 13.1469L1.70627 8.49999H13.5C13.775 8.49999 14 8.27499 14 7.99999C14 7.72499 13.775 7.49999 13.5 7.49999H1.70627L6.35315 2.85312C6.5469 2.65937 6.5469 2.34062 6.35315 2.14687C6.1594 1.95312 5.84065 1.95312 5.6469 2.14687L0.146899 7.64687Z" fill="white"/>
                    </g>
                    <defs>
                      <clipPath id="clip0_6_380">
                        <rect width="14" height="16" fill="white"/>
                      </clipPath>
                    </defs>
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div v-if="step === 4">
        <div class="step" id="step-4">
          <div class="col-12 col-lg-6 offset-lg-3  py-12 lg:py-0  ">
            <div class="grid content-start">
              <div class="hora-form-step">
                <div class="hora-form-city mb-6">
                  <div class="flex flex-row items-center gap-2.5">
                    <svg width="15" height="20" viewBox="0 0 15 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_8_163)">
                        <path d="M13.75 7.5C13.75 4.04688 10.9531 1.25 7.5 1.25C4.04688 1.25 1.25 4.04688 1.25 7.5C1.25 8.10938 1.46094 8.94531 1.89844 9.97656C2.32422 10.9883 2.92188 12.0859 3.60156 13.1836C4.93359 15.3438 6.50781 17.4102 7.50391 18.6523C8.49609 17.4102 10.0742 15.3438 11.4062 13.1836C12.082 12.0859 12.6836 10.9844 13.1094 9.97656C13.5391 8.94531 13.75 8.10938 13.75 7.5ZM15 7.5C15 10.9141 10.4297 16.9922 8.42578 19.5C7.94531 20.0977 7.05469 20.0977 6.57422 19.5C4.57031 16.9922 0 10.9141 0 7.5C0 3.35938 3.35938 0 7.5 0C11.6406 0 15 3.35938 15 7.5ZM5.625 7.5C5.625 7.99728 5.82254 8.47419 6.17417 8.82583C6.52581 9.17746 7.00272 9.375 7.5 9.375C7.99728 9.375 8.47419 9.17746 8.82583 8.82583C9.17746 8.47419 9.375 7.99728 9.375 7.5C9.375 7.00272 9.17746 6.52581 8.82583 6.17417C8.47419 5.82254 7.99728 5.625 7.5 5.625C7.00272 5.625 6.52581 5.82254 6.17417 6.17417C5.82254 6.52581 5.625 7.00272 5.625 7.5ZM7.5 10.625C6.6712 10.625 5.87634 10.2958 5.29029 9.70971C4.70424 9.12366 4.375 8.3288 4.375 7.5C4.375 6.6712 4.70424 5.87634 5.29029 5.29029C5.87634 4.70424 6.6712 4.375 7.5 4.375C8.3288 4.375 9.12366 4.70424 9.70971 5.29029C10.2958 5.87634 10.625 6.6712 10.625 7.5C10.625 8.3288 10.2958 9.12366 9.70971 9.70971C9.12366 10.2958 8.3288 10.625 7.5 10.625Z" fill="#002E5B"/>
                      </g>
                      <defs>
                        <clipPath id="clip0_8_163">
                          <rect width="15" height="20" fill="white"/>
                        </clipPath>
                      </defs>
                    </svg>
                    <h5 class="hora-text-primary inline text-xl m-0">شهر محل تولد</h5>
                  </div>
                  <div class="mt-6">
                    <div class="relative">
                      <div class="city_selector">
                        <autocomplete
                          :style="`display: block; width: 100%; border: ${errors.location_error} 1px solid; color: #64748b; background-color: #f1f5f9; padding: 0.5rem 0.75rem; border-radius: 0.5rem; `"
                          aria-label="جستجوی موقعیت جغرافیایی"
                          placeholder="شهر محل تولد"
                          :search="search"
                          :get-result-value="getResultValue"
                          @submit="handleSubmit"
                          id="location-autocomplete"
                        >
                        </autocomplete>
                      </div>
                    </div>
                  </div>
                </div>
                <hr>
                <div class="hora-form-time-zone mt-6 mb-6">
                  <h5 class="hora-text-disabled inline text-xl">منطقه زمانی</h5>
                  <p class="mt-3 hora-text-disabled leading-10">منطقه زمانی به طور خودکار براساس مکان تولد محاسبه شده است.</p>
                  <TimezoneSelector
                    :input_disabled="auto_timezone"
                    :default_input="chart_request.timezone"
                  ></TimezoneSelector>
                </div>
              </div>
              <div class="hora-form-buttons grid grid-cols-2 gap-4">
                <a @click="previousStep" class="flex justify-center relative items-center rounded-lg py-2 px-3 text-slate-400 bg-slate-200 border border-slate-300" disabled>
                  <svg class="absolute right-3" width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13.8531 8.35313C14.0469 8.15938 14.0469 7.84063 13.8531 7.64688L8.3531 2.14688C8.15935 1.95313 7.8406 1.95313 7.64685 2.14688C7.4531 2.34063 7.4531 2.65938 7.64685 2.85313L12.2937 7.50001L0.499976 7.50001C0.224976 7.5 -2.42471e-05 7.725 -2.42711e-05 8C-2.42952e-05 8.27501 0.224976 8.5 0.499976 8.50001L12.2937 8.50001L7.64685 13.1469C7.4531 13.3406 7.4531 13.6594 7.64685 13.8531C7.8406 14.0469 8.15935 14.0469 8.3531 13.8531L13.8531 8.35313Z" fill="#002E5B"/>
                  </svg>
                  <span>  قبلی</span>
                </a>
                <a id="nextStep01" @click="nextStep"  class="flex justify-center relative items-center rounded-lg py-2 px-3 hora-bg-primary text-white">
                  <span>  بعدی</span>
                  <svg class="absolute left-3" width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_6_380)">
                      <path d="M0.146899 7.64687C-0.0468506 7.84062 -0.0468506 8.15937 0.146899 8.35312L5.6469 13.8531C5.84065 14.0469 6.1594 14.0469 6.35315 13.8531C6.5469 13.6594 6.5469 13.3406 6.35315 13.1469L1.70627 8.49999H13.5C13.775 8.49999 14 8.27499 14 7.99999C14 7.72499 13.775 7.49999 13.5 7.49999H1.70627L6.35315 2.85312C6.5469 2.65937 6.5469 2.34062 6.35315 2.14687C6.1594 1.95312 5.84065 1.95312 5.6469 2.14687L0.146899 7.64687Z" fill="white"/>
                    </g>
                    <defs>
                      <clipPath id="clip0_6_380">
                        <rect width="14" height="16" fill="white"/>
                      </clipPath>
                    </defs>
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div v-if="step === 5">
        <ChartModal :chartRequest="chart_request" @submit-chart="submitChart" @previousStep="previousStep"/>
      </div>


    </div>
    <Loading :is-loading="isLoading" />
  </div>
</template>

<script>
import DatePicker from "./DatePicker.vue";
import TimePicker from "./TimePicker.vue";
import Autocomplete from "@trevoreyre/autocomplete-vue";
import ApiService from "../service/api";
import DSTSelector from "./DSTSelector.vue";
import TimezoneSelector from "./TimezoneSelector.vue";

import HelperLib from "./helper";
import Loading from "./Loading.vue";
import HoraStats from "./HoraStats.vue";
import ChartModal from "./ChartModal.vue";
import jalaali from 'jalaali-js';

export default {
  name: "careerReportForm",
  components: {
    ChartModal, HoraStats,
    Loading,
    DatePicker,
    Autocomplete,
    TimezoneSelector,
    DSTSelector,
    TimePicker,
  },
  props: {
    t_year: null,
    t_month: null,
    t_day: null,
    t_hour: null,
    t_min: null,
    t_sec: null,
  },
  data() {
    return {
      auto_location: true,
      auto_timezone: true,
      only_county: false,
      isLoading: false,
      step: 1,
      errors: {
        name_error: "none",
        gender_error: "none",
        time_error: "none",
        date_error: "none",
        location_error: "transparent",
      },

      dms_error: false,
      input_lat_min: "",
      input_lat_deg: "",
      input_lat_min_sign: "",
      input_lat_dir: "",
      input_lon_min: "",
      input_lon_deg: "",
      input_lon_dir: "",
      input_lon_min_sign: "",

      lat_loc_deg_range: this.getRange(0, 90),
      lat_loc_dir: ["N", "S"],
      lat_loc_min_range: this.getRange(0, 60),

      lat_dir_search: null,
      lat_deg_search: null,
      lat_min_search: null,

      lon_loc_deg_range: this.getRange(0, 180),
      lon_loc_dir: ["E", "W"],
      lon_loc_min_range: this.getRange(0, 60),

      lon_dir_search: null,
      lon_deg_search: null,
      lon_min_search: null,

      is_advance_form: false,
      datepicker_column: {
        576: 1, // under 576px, column count is 1
        992: 2, // under 992px, column count is 2
      },
      chart_request: {
        title: "",
        display_loc: '',
        latitude: null,
        longitude: null,
        altitude: null,
        year: null,
        gender: null,
        month: null,
        day: null,
        hour: null,
        min: null,
        sec: null,
        timezone: null,
        city: null,
        state: null,
        country: null,
        tz_country: null,
        date_type: null,
        dasha_date_type: null,
        vargas: null,
        nesting: null,
        t_date_type: null,
        dst_min: "0",
        dst_hour: "0",
        lat_deg: null,
        lat_min: null,
        lat_sec: null,
        lat_dir: null,
        lon_deg: null,
        lon_min: null,
        lon_sec: null,
        lon_dir: null,
      },
      site_url: null,
      chart_result: Object,
      wizardSteps: {
        1: '',
        2: '',
        3: '',
        4: ''
      },
    };
  },

  mounted: function() {
    this.loadSettings_birth_hints();
    this.site_url = process.env.BASE_URL;
  },

  watch: {
    input_lat_min: function (value) {
      // console.log(value);
      if (value.charAt(0) === "-" && value.length > 3) {
        this.input_lat_min = value.substring(1, 3);
      }
      if (value.charAt(0) !== "-" && value.length > 2) {
        this.input_lat_min = value.substring(0, 2);
      }
      const regex = /^0?[0-9]|[1-5][0-9]$/;
      if (!regex.test(value) && value) {
        this.dms_error = true;
      } else {
        this.dms_error = false;
        this.chart_request.lat_min = this.input_lat_min;
      }
    },
    input_lat_deg: function (value) {
      if (value.length > 3) {
        this.input_lat_deg = value.substring(0, 3);
      }
      const regex = /^(?:\d{1,2}|1[0-7]\d|180)$/;
      if (!regex.test(value) && value) {
        this.input_lat_deg = value.substring(0, 3);
        this.dms_error = true;
      } else {
        this.dms_error = false;
        this.chart_request.lat_deg = this.input_lat_deg;
      }
    },

    input_lon_min: function (value) {
      // console.log(value);
      if (value.charAt(0) === "-" && value.length > 3) {
        this.input_lon_min = value.substring(1, 3);
      }
      if (value.charAt(0) !== "-" && value.length > 2) {
        this.input_lon_min = value.substring(0, 2);
      }
      const regex = /^0?[0-9]|[1-5][0-9]$/;
      if (!regex.test(value) && value) {
        this.dms_error = true;
      } else {
        this.dms_error = false;
        this.chart_request.lon_min = this.input_lon_min;
      }
    },
    input_lon_deg: function (value) {
      if (value.length > 3) {
        this.input_lon_deg = value.substring(0, 3);
      }
      const regex = /^(?:\d{1,2}|1[0-7]\d|180)$/;
      if (!regex.test(value) && value) {
        this.input_lon_deg = value.substring(0, 3);
        this.dms_error = true;
      } else {
        this.dms_error = false;
        this.chart_request.lon_deg = this.input_lon_deg;
      }
    },

    // input_lon_dir: function (value) {
    //   console.log(value)
    //   if(value === "N" || value === "S"){
    //     this.input_lon_dir = value
    //     this.chart_request.lon_dir = value
    //   }
    // },
    // input_lat_dir: function (value) {
    //   console.log(value)
    //   if(value === "W" || value === "E"){
    //     this.input_lat_dir = value
    //     this.chart_request.lat_dir = value
    //   }
    // },
  },
  methods: {


    loadSettings_birth_hints: function() {
      fetch("/wp-admin/admin-ajax.php", {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: new URLSearchParams({
          action: 'get_birth_chart_hints',
        })
      })
        .then(response => response.json())
        .then(data => {
          if (data.success) {
            this.wizardSteps = data.data;
          } else {
            console.error('اطلاعات دریافت نشد!!!!!!!');
          }
        });
    },
    stepText() {
      switch (this.step) {
        case 1:
          return this.wizardSteps['1'];
        case 2:
          return this.wizardSteps['2'];
        case 3:
          return this.wizardSteps['3'];
        case 4:
          return this.wizardSteps['4'];
        default:
          return '';
      }
    },
    nextStep() {
      if (this.step === 1) {
        if (
          this.chart_request.title === "" ||
          String(this.chart_request.title).length < 3
        ) {
          this.errors.name_error = "block";
        }
        if (this.chart_request.title != "" && String(this.chart_request.title).length > 1) {
          this.errors.name_error = "none";
        }
        if (this.chart_request.gender === null) {
          this.errors.gender_error = "block";
        }
        if (this.chart_request.gender != null) {
          this.errors.gender_error = "none";
        }
        if (this.chart_request.gender === null || this.chart_request.title === "") {
          return;
        }

      } else if (this.step === 2) {

        if (this.chart_request.year === null) {
          this.errors.date_error = "block";
        }

        if (this.chart_request.year != null) {
          this.errors.date_error = "none";
        }

        if (
          this.chart_request.year === null
        ) {
          return;
        }
      }
      else if (this.step === 3) {


        var hour = this.chart_request.hour ? this.chart_request.hour.length : 0;

        var min =  this.chart_request.min ? this.chart_request.min.length : 0

        if (
          hour === 0 || min === 0
        ) {
          this.errors.time_error = "block";
        }

        if (hour !== 0 && min !== 0) {
          this.errors.time_error = "none";
        }

        if (
          hour === 0 || min === 0
        ) {
          return;
        }


      }

      else if (this.step === 4) {

        if (this.chart_request.longitude == null) {
          this.errors.location_error = "red";
        }
        if (
          this.chart_request.longitude === null
        ) {
          return;
        }
      }
      if (this.step < 5) {
        this.step++;
      }
    },
    previousStep() {
      if (this.step > 1) {
        this.step--;
      }
    },




    validateLatMin(e) {
      const regex = /^[0-9]$/;
      const newMinValue = this.input_lat_min + e.key;

      if (!regex.test(e.key) && e.key !== "Backspace" && e.key !== "Delete") {
        e.preventDefault();
      } else if (parseInt(newMinValue) > 59 || newMinValue.length > 2) {
        e.preventDefault();
      }
    },
    validateLatDeg(e) {
      const regex = /^[0-9]$/;
      const newDegreeValue = this.input_lat_deg + e.key;

      if (!regex.test(e.key) && e.key !== "Backspace" && e.key !== "Delete") {
        e.preventDefault();
      } else if (parseInt(newDegreeValue) > 90 || newDegreeValue.length > 2) {
        e.preventDefault();
      }
    },
    validateLonMin(e) {
      const regex = /^[0-9]$/;
      const newMinValue = this.input_lon_min + e.key;

      if (!regex.test(e.key) && e.key !== "Backspace" && e.key !== "Delete") {
        e.preventDefault();
      } else if (parseInt(newMinValue) > 59 || newMinValue.length > 2) {
        e.preventDefault();
      }
    },
    validateLonDeg(e) {
      const regex = /^[0-9]$/;
      const newDegreeValue = this.input_lon_deg + e.key;

      if (!regex.test(e.key) && e.key !== "Backspace" && e.key !== "Delete") {
        e.preventDefault();
      } else if (parseInt(newDegreeValue) > 181 || newDegreeValue.length > 3) {
        e.preventDefault();
      }
    },

    changeAutoTimezone() {
      // this.auto_timezone = !this.auto_timezone;
      if (this.auto_timezone == true) {
        this.handlerNearestTimezone();
      }
    },
    getRange(start, end) {
      const result = [];
      for (let i = start; i <= end; i++) {
        result.push(i.toString());
      }
      return result;
    },
    updateFormDate(year, month, day, date_type) {
      this.chart_request.year = year;
      this.chart_request.month = month;
      this.chart_request.day = day;
      this.chart_request.date_type = date_type;
    },
    updateFormTime(hour, min, sec) {
      this.chart_request.hour = hour;
      this.chart_request.min = min;
      this.chart_request.sec = sec;
    },
    updateFormTimezone(tz) {
      // console.log("TEST", tz)
      this.chart_request.timezone = tz;
    },
    updateDSToffset(dst_value) {
      switch (dst_value) {
        case "0":
          this.chart_request.dst_hour = "0";
          this.chart_request.dst_min = "0";
          break;
        case "1":
          this.chart_request.dst_hour = "0";
          this.chart_request.dst_min = "30";
          break;
        case "2":
          this.chart_request.dst_hour = "1";
          this.chart_request.dst_min = "0";
          break;
        case "3":
          this.chart_request.dst_hour = "1";
          this.chart_request.dst_min = "30";
          break;
        case "4":
          this.chart_request.dst_hour = "2";
          this.chart_request.dst_min = "0";
          break;
      }
    },
    validateForm() {
      let result = true;

      this.errors.name_error = this.chart_request.title === "" ? "block" : "none";
      this.errors.time_error = this.chart_request.hour === null ? "block" : "none";
      this.errors.date_error = this.chart_request.year === null ? "block" : "none";
      this.errors.location_error =
        this.chart_request.longitude === null ? "red" : "transparent";

      const requiredFields = [
        this.chart_request.title,
        this.chart_request.hour,
        this.chart_request.year,
        this.chart_request.month,
        this.chart_request.day,
        this.chart_request.longitude,
        // this.chart_request.gender,
      ];

      for (const field of requiredFields) {
        if (field === "" || field === null) {
          result = false;
          break;
        }
      }

      return result;
    },

    resetFormErrors() {},
    showFormErrors() {},
    submitChart() {
      // return this.test_submitChart();
      // console.log(this.auto_location);
      if (this.auto_location == false) {
        this.chart_request.latitude = HelperLib.convertDMSToDegree(
          this.chart_request.lat_deg,
          this.chart_request.lat_min,
          this.chart_request.lat_sec,
          this.chart_request.lat_dir
        );
        this.chart_request.longitude = HelperLib.convertDMSToDegree(
          this.chart_request.lon_deg,
          this.chart_request.lon_min,
          this.chart_request.lon_sec,
          this.chart_request.lon_dir
        );
        if (this.auto_timezone) {
          this.handlerNearestTimezone();
        }
      }
      if (this.validateForm()) {
        this.isLoading = true;
        ApiService.makecareerReportOrder(this.chart_request).then((response) => {
//          console.log(response);
          this.isLoading = false;
          window.location.replace(response["data"]["pre_order"]);
        });
      }
    },
    search(input) {
      return new Promise((resolve) => {
        let url = `https://nominatim.openstreetmap.org/search?format=geojson&limit=5&addressdetails=1&city=${encodeURI(
          input
        )}`;

        // console.log(this.only_county);
        if (this.only_county) {
          url = `https://nominatim.openstreetmap.org/search?format=geojson&limit=5&addressdetails=1&country=${encodeURI(
            input
          )}`;
        }
        if (input.length < 3) {
          return resolve([]);
        }
        fetch(url)
          .then((response) => response.json())
          .then((data) => {
            resolve(data.features);
          });
      });
    },
    getResultValue(result) {
      let _c = result["properties"]["address"]["country"]
        ? result["properties"]["address"]["country"]
        : "بدون کشور";
      let _m = result["properties"]["address"]["state"]
        ? result["properties"]["address"]["state"]
        : result["properties"]["address"]["province"]
        ? result["properties"]["address"]["province"]
        : result["properties"]["address"]["region"]
        ? result["properties"]["address"]["region"]
        : "";
      let _ci = result["properties"]["address"]["city"]
        ? result["properties"]["address"]["city"]
        : result["properties"]["address"]["village"]
        ? result["properties"]["address"]["village"]
        : result["properties"]["address"]["hamlet"]
        ? result["properties"]["address"]["hamlet"]
        : "";
      let _vi = result["properties"]["address"]["town"]
        ? result["properties"]["address"]["town"]
        : "";

      return result["properties"]['name'] + " - " + _m + " - " + _c;
    },
    handleSubmit(result) {
      // console.log(result);
      this.chart_request.longitude = result["geometry"]["coordinates"][0];
      this.chart_request.latitude = result["geometry"]["coordinates"][1];
      this.chart_request.tz_country = result["properties"]["address"]["country_code"];
      this.chart_request.city = result["properties"]["address"]["city"]
        ? result["properties"]["address"]["city"]
        : result["properties"]["address"]["village"]
        ? result["properties"]["address"]["village"]
        : result["properties"]["address"]["hamlet"];
      this.chart_request.state = result["properties"]["address"]["state"]
        ? result["properties"]["address"]["state"]
        : result["properties"]["address"]["province"]
        ? result["properties"]["address"]["province"]
        : result["properties"]["address"]["region"];
      this.chart_request.display_loc = result["properties"]['display_name']
      this.chart_request.country = result["properties"]["address"]["country"];

      const lon_dms = HelperLib.convertDegreeToDMS(this.chart_request.longitude, true);
      const lat_dms = HelperLib.convertDegreeToDMS(this.chart_request.latitude);

      this.input_lon_deg = lon_dms["deg"];
      this.chart_request.lon_deg = this.input_lon_deg;

      this.chart_request.lon_dir = lon_dms["dir"];

      if (lon_dms["min"].toString().charAt(0) === "-") {

        this.input_lon_min = lon_dms["min"].toString().substring(1, 3);
      } else {

        this.input_lon_min = lon_dms["min"].toString();
      }
      this.chart_request.lon_min = lon_dms["min"];
      this.chart_request.lon_sec = lon_dms["sec"];
      this.chart_request.lat_dir = lat_dms["dir"];
      this.input_lat_deg = lat_dms["deg"];
      this.chart_request.lat_deg = this.input_lat_deg;

      if (lat_dms["min"].toString().charAt(0) === "-") {
        this.input_lat_min = lat_dms["min"].toString().substring(1, 3);
      } else {
        this.input_lat_min = lat_dms["min"].toString();
      }

      this.chart_request.lat_min = this.input_lat_min;
      this.chart_request.lat_sec = lon_dms["sec"];

      const year = this.chart_request.year;
      const day = this.chart_request.day;
      const month = this.chart_request.month;
      const date_type = this.chart_request.date_type;
      if (date_type !== "gregorian" && this.chart_request.country === "Iran" ||
        this.chart_request.country === "iran" ||
        this.chart_request.country === "ایران") {

        let dst_hour = "0";
        let dst_min = "0";
        let alert_type = 'default';
        let alert_text = null;

        let gregorianYear;
        if (month === 6 && day === 31 && year >= 1371) {
          console.log("The Hsahrivar Restrictions Worked")
          dst_hour = "0";
          dst_min = "0";
          alert_type = 'default';
          alert_text = null;
        } else {

          console.log("else The Hsahrivar Restrictions Worked")

        if (year < 1700) {
          gregorianYear = jalaali.toGregorian(year, month, 1).gy;
        } else {
          gregorianYear = year;
        }
        if (month <= 6) {

          if ((year >= 1356 && year <= 1401) || (gregorianYear >= 1977 && gregorianYear <= 2021)) {
            if (gregorianYear === 1977 && month >= 11) {
              dst_hour = "0.5";
              dst_min = "0";
              alert_text = 'ساعت DST به 0.5 به روز شد';
            } else if (gregorianYear === 1978) {
              if (month <= 6) {
                dst_hour = "1";
                // alert_text = 'ساعت DST به 1 به روز شد';
                alert_text = 'در زمان تولد شما ساعت روشنایی وجود داشته است و در محاسبات اعمال شده است';
              } else if (month > 6) {
                dst_hour = "0.5";
                // alert_text = 'ساعت DST به 0.5 به روز شد';
                alert_text = 'در زمان تولد شما ساعت روشنایی وجود داشته است و در محاسبات اعمال شده است';
              }
              dst_min = "0";
            } else if (gregorianYear === 1979 || gregorianYear === 1980) {
              if (month <= 6) {
                dst_hour = "1";
                alert_text = 'در زمان تولد شما ساعت روشنایی وجود داشته است و در محاسبات اعمال شده است';
                // alert_text = 'ساعت DST به 1 به روز شد';
              } else {
                dst_hour = "0";
                dst_min = "0";
                alert_text = 'ساعت DST به 0 به روز شد';
              }
            } else if ((gregorianYear >= 1992 && gregorianYear <= 2005) || gregorianYear >= 2008) {
              if (month <= 6) {
                dst_hour = "1";
                // alert_text = 'ساعت DST به 1 به روز شد';
                alert_text = 'در زمان تولد شما ساعت روشنایی وجود داشته است و در محاسبات اعمال شده است';
              } else {
                dst_hour = "0";
                dst_min = "0";
                alert_text = 'در زمان تولد شما ساعت روشنایی وجود داشته است و در محاسبات اعمال شده است';
                // alert_text = 'ساعت DST به 0 به روز شد';
              }
            }
            alert_type = 'updated';
          }
        }

        }

        this.chart_request.dst_hour = dst_hour;
        this.chart_request.dst_min = dst_min;
        this.chart_request.alert_type = alert_type;
        this.chart_request.alert_text = alert_text;
      }
      this.handlerNearestTimezone();
    },
    handlerNearestTimezone() {
      let request = {
        latitude: this.chart_request.latitude,
        longitude: this.chart_request.longitude,
        tz_country: this.chart_request.tz_country,
      };

      if (this.chart_request.tz_country == 'ir'){
        this.chart_request.timezone = "+03:30";
      } else {
        HelperLib.showLoading();
        this.isLoading = true;
        ApiService.getNearestTimezone(request).then((response) => {
          this.chart_request.timezone = response["data"][1];
          this.isLoading = false;
          // console.log(response);
          HelperLib.hideLoading();
        });
      }

    },
  },
};
</script>

<style>
.autocomplete-input {
  border: 1px solid #eee;
  border-radius: 8px;
  width: 100%;
  padding: 12px 48px 12px 12px;
  box-sizing: border-box;
  position: relative;
  font-size: 16px;
  line-height: 1.5;
  flex: 1;
  background-color: #eee;
  background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjNjY2IiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+PGNpcmNsZSBjeD0iMTEiIGN5PSIxMSIgcj0iOCIvPjxwYXRoIGQ9Ik0yMSAyMWwtNC00Ii8+PC9zdmc+");
  background-repeat: no-repeat;
  background-position: calc(100% - 10px);
  background-size: 20px;
  text-align: center;
}

.autocomplete-input:focus,
.autocomplete-input[aria-expanded="true"] {
  border-color: rgba(0, 0, 0, 0.12);
  background-color: #fff;
  outline: none;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.16);
}

.autocomplete-input::placeholder {
  font-size: 16px;
}

[data-position="below"] .autocomplete-input[aria-expanded="true"] {
  border-bottom-color: transparent;
  border-radius: 8px 8px 0 0;
}

[data-position="above"] .autocomplete-input[aria-expanded="true"] {
  border-top-color: transparent;
  border-radius: 0 0 8px 8px;
  z-index: 2;
}

.autocomplete[data-loading="true"]:after {
  content: "";
  border: 3px solid rgba(0, 0, 0, 0.12);
  border-right-color: rgba(0, 0, 0, 0.48);
  border-radius: 100%;
  width: 20px;
  height: 20px;
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  animation: rotate 1s linear infinite;
}

.autocomplete-result-list {
  font-size: 16px;
  margin: 0;
  border: 1px solid rgba(0, 0, 0, 0.12);
  padding: 0;
  box-sizing: border-box;
  max-height: 296px;
  overflow-y: auto;
  background: #fff;
  list-style: none;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.16);
}

[data-position="below"] .autocomplete-result-list {
  margin-top: -1px;
  border-top-color: transparent;
  border-radius: 0 0 8px 8px;
  padding-bottom: 8px;
}

[data-position="above"] .autocomplete-result-list {
  margin-bottom: -1px;
  border-bottom-color: transparent;
  border-radius: 8px 8px 0 0;
  padding-top: 8px;
}

.autocomplete-result {
  font-size: 16px;
  cursor: default;
  padding: 12px 48px 12px 12px;
  background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjY2NjIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+PGNpcmNsZSBjeD0iMTEiIGN5PSIxMSIgcj0iOCIvPjxwYXRoIGQ9Ik0yMSAyMWwtNC00Ii8+PC9zdmc+");
  background-repeat: no-repeat;
  background-position: calc(100% - 10px);
}

.autocomplete-result:hover,
.autocomplete-result[aria-selected="true"] {
  background-color: rgba(0, 0, 0, 0.06);
}

@keyframes rotate {
  0% {
    transform: translateY(-50%) rotate(0deg);
  }
  to {
    transform: translateY(-50%) rotate(359deg);
  }
}
.h-input-group {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
  margin: 5px;
  outline: none;
}
.h-input-wrapper {
  font-weight: 400;
  font-size: 1rem;
  line-height: 1.5;
  align-items: center;
  display: flex;
  flex: 1 1 auto;
  flex-wrap: wrap;
  width: 100%;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  height: 100%;
  box-sizing: border-box;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;
}
.h-input {
  font-size: 1rem;
  background-size: 25px 25px;
  background-position: right 10px center;
  background-repeat: no-repeat;
  color: #495057 !important;
  background-color: transparent;
  border-style: none;
  pointer-events: auto;
  flex: 1 1;
  margin-top: 0;
  min-width: 0;
  position: relative;
  line-height: 20px;
  max-width: 100%;
  width: 100%;
  height: calc(1.5em + 0.75rem);
  padding: 0.375rem 0.75rem;
  border-radius: 0.25rem;
  text-align: center;
}

.h-input:focus {
  border-color: #80bdff;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgb(128 189 255 / 50%);
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;
}
.h-input-picker {
  font-size: 1rem;
  background-size: 25px 25px;
  background-position: right 10px center;
  background-repeat: no-repeat;
  color: #495057 !important;
  background-color: white;
  border: 1px solid #ccc;
  pointer-events: auto;
  flex: 1 1;
  margin-top: 0;
  min-width: 0;
  padding: 7px;
  border-radius: 5px;
  position: relative;
  line-height: 20px;
  max-width: 100%;
  width: 100%;
  text-align: center;
}

.h-input-picker-wrapper {
  align-items: center;
  display: flex;
  flex: 1 1 auto;
  flex-wrap: wrap;
  width: 100%;
  color: #495057;
}

.h-error {
  width: 100%;
  font-size: 12px;
  color: red;
}
</style>

<style scoped>
.chart-input {
  border: 1px solid #eee;
  border-radius: 8px;
  width: 100%;
  padding: 12px 48px 12px 12px;
  box-sizing: border-box;
  position: relative;
  font-size: 16px;
  line-height: 1.5;
  flex: 1;
  text-align: center;
  background-color: #eee;
  background-repeat: no-repeat;
  background-position: right;
  margin: 0;
}

.chart-input:focus,
.chart-input[aria-expanded="true"] {
  border-color: rgba(0, 0, 0, 0.12);
  background-color: #fff;
  outline: none;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.16);
}

.chart-datepicker {
  border: none;
  padding: none;
  margin: none;
  width: 100%;
}

.chart-datepicker > input {
  background: #eee;
}

.chart-datetime {
  background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgZmlsbD0iY3VycmVudENvbG9yIiBjbGFzcz0iYmkgYmktY2FsZW5kYXItY2hlY2siIHZpZXdCb3g9IjAgMCAxNiAxNiI+CiAgPHBhdGggZD0iTTEwLjg1NCA3LjE0NmEuNS41IDAgMCAxIDAgLjcwOGwtMyAzYS41LjUgMCAwIDEtLjcwOCAwbC0xLjUtMS41YS41LjUgMCAxIDEgLjcwOC0uNzA4TDcuNSA5Ljc5M2wyLjY0Ni0yLjY0N2EuNS41IDAgMCAxIC43MDggMHoiLz4KICA8cGF0aCBkPSJNMy41IDBhLjUuNSAwIDAgMSAuNS41VjFoOFYuNWEuNS41IDAgMCAxIDEgMFYxaDFhMiAyIDAgMCAxIDIgMnYxMWEyIDIgMCAwIDEtMiAySDJhMiAyIDAgMCAxLTItMlYzYTIgMiAwIDAgMSAyLTJoMVYuNWEuNS41IDAgMCAxIC41LS41ek0xIDR2MTBhMSAxIDAgMCAwIDEgMWgxMmExIDEgMCAwIDAgMS0xVjRIMXoiLz4KPC9zdmc+);
  background-position: calc(100% - 10px);
  text-align: center;
}

.chart-title {
  background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgZmlsbD0iY3VycmVudENvbG9yIiBjbGFzcz0iYmkgYmktaW5wdXQtY3Vyc29yLXRleHQiIHZpZXdCb3g9IjAgMCAxNiAxNiI+CiAgPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNNSAyYS41LjUgMCAwIDEgLjUtLjVjLjg2MiAwIDEuNTczLjI4NyAyLjA2LjU2Ni4xNzQuMDk5LjMyMS4xOTguNDQuMjg2LjExOS0uMDg4LjI2Ni0uMTg3LjQ0LS4yODZBNC4xNjUgNC4xNjUgMCAwIDEgMTAuNSAxLjVhLjUuNSAwIDAgMSAwIDFjLS42MzggMC0xLjE3Ny4yMTMtMS41NjQuNDM0YTMuNDkgMy40OSAwIDAgMC0uNDM2LjI5NFY3LjVIOWEuNS41IDAgMCAxIDAgMWgtLjV2NC4yNzJjLjEuMDguMjQ4LjE4Ny40MzYuMjk0LjM4Ny4yMjEuOTI2LjQzNCAxLjU2NC40MzRhLjUuNSAwIDAgMSAwIDEgNC4xNjUgNC4xNjUgMCAwIDEtMi4wNi0uNTY2QTQuNTYxIDQuNTYxIDAgMCAxIDggMTMuNjVhNC41NjEgNC41NjEgMCAwIDEtLjQ0LjI4NSA0LjE2NSA0LjE2NSAwIDAgMS0yLjA2LjU2Ni41LjUgMCAwIDEgMC0xYy42MzggMCAxLjE3Ny0uMjEzIDEuNTY0LS40MzQuMTg4LS4xMDcuMzM1LS4yMTQuNDM2LS4yOTRWOC41SDdhLjUuNSAwIDAgMSAwLTFoLjVWMy4yMjhhMy40OSAzLjQ5IDAgMCAwLS40MzYtLjI5NEEzLjE2NiAzLjE2NiAwIDAgMCA1LjUgMi41LjUuNSAwIDAgMSA1IDJ6Ii8+CiAgPHBhdGggZD0iTTEwIDVoNGExIDEgMCAwIDEgMSAxdjRhMSAxIDAgMCAxLTEgMWgtNHYxaDRhMiAyIDAgMCAwIDItMlY2YTIgMiAwIDAgMC0yLTJoLTR2MXpNNiA1VjRIMmEyIDIgMCAwIDAtMiAydjRhMiAyIDAgMCAwIDIgMmg0di0xSDJhMSAxIDAgMCAxLTEtMVY2YTEgMSAwIDAgMSAxLTFoNHoiLz4KPC9zdmc+);
  background-position: calc(100% - 10px);
  text-align: center;
  background-size: 20px;
  height: 55px;
}

.chart-form {
  background: #fff;
  border-radius: 8px;
  border: 1px solid #ccc;
}

.save-btn {
  cursor: pointer;
  border-radius: 8px;
  padding: 8px;
  padding-right: 20px;
  padding-left: 20px;
  width: fit-content;
  color: #fff;
  border: 1px #ccc solid;
  border-color: rgba(0, 0, 0, 0.12);
  background-color: #339966;
  outline: none;
  font-size: 16px;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.16);
  background: no-repeat
    url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 448 512'%3E%3C!--! Font Awesome Free 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License) Copyright 2022 Fonticons, Inc. --%3E%3Cpath d='M433.1 129.1l-83.9-83.9C342.3 38.32 327.1 32 316.1 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V163.9C448 152.9 441.7 137.7 433.1 129.1zM224 416c-35.34 0-64-28.66-64-64s28.66-64 64-64s64 28.66 64 64S259.3 416 224 416zM320 208C320 216.8 312.8 224 304 224h-224C71.16 224 64 216.8 64 208v-96C64 103.2 71.16 96 80 96h224C312.8 96 320 103.2 320 112V208z'/%3E%3C/svg%3E");
}

.calculate-btn {
  cursor: pointer;
  border-radius: 8px;
  padding: 8px;
  padding-right: 20px;
  padding-left: 20px;
  width: fit-content;
  color: #fff;
  border: 1px #ccc solid;
  border-color: rgba(0, 0, 0, 0.12);
  background-color: #339966;
  outline: none;
  font-size: 16px;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.16);
}

.calculate-btn:hover {
  transition: all 1s;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.5);
}

.gender-input {
  background-image: url(data:image/svg+xml;base64,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);
}

.gender-box {
  direction: rtl;
  border: none;
  border-radius: 8px;
  background-color: #eee;
  width: 100%;
  font-size: 16px;
  background-repeat: no-repeat;
  background-size: 22px;
  background-position-x: calc(100% - 10px);
  padding: 12px 48px 12px 12px;
  text-align: center;
  height: 55px;
  margin: 0px;
}

.input-wrapper {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
  margin: 5px;
}

.location-detail {
  text-align: center;
  border: none;
  border-radius: 8px;
  background-color: #eee;
  font-size: 16px;
  text-align: center;
  margin: 0px;
  height: auto;
}
</style>
